export default __webpack_public_path__ + "images/49_2_image.jpg";